import {fetchBaseQuery, createApi} from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
    baseUrl: 'https://api.myoctoopidev.com/v3'
});

export const apiSlice = createApi({
    baseQuery,
    tagTypes: ['User', 'Vehicle', 'Setting', 'Role'],
    endpoints: (builder) => ({}),
});
